export default "__VITE_ASSET__DNtBYOWn__"